import Cookies from "universal-cookie";
import {ReactNode, createContext, useEffect, useRef, useState} from "react";
import { CounselorLoginType, CounselorUserType, StudentLoginType, StudentUserType } from "../types/User";
import { requestForToken } from "../firebase";
import { useResilientAxios } from "../network/useResilientAxios";

type UserContextType = {
    token: string | undefined | null;
    user: CounselorUserType | StudentUserType;
    FCMToken: string | null;
    logout: () => void;
    updateUser: (data: CounselorLoginType | StudentLoginType, token?: string | undefined) => void,
    updateScore: () => void;
}

const UserContext = createContext<UserContextType | null>(null)

type UserContextProviderProps = {
    children: ReactNode
}

export function UserContextProvider({ children }: UserContextProviderProps) {
    const { axios, activeEndpoint, switching } = useResilientAxios();

    const cookies = new Cookies();
    const [FCMToken, setFCMToken] = useState<string | null>(null);

    const [user, setUser] = useState<CounselorUserType | StudentUserType>(cookies.get('currentUser') ? cookies.get('currentUser')['user'] : cookies.get('adminUser')?.['user'])
    const [token, setToken] = useState<string | undefined | null>(cookies.get('currentUser') ? cookies.get('currentUser')['token'] : cookies.get('adminUser')?.['token']); 

    function logout() {
        cookies.remove('currentUser', {path: '/'});
        
        const examAnalysisDraft = localStorage.getItem('exam-draft') || '{}';
        window.localStorage.clear();
        window.localStorage.setItem('exam-draft', examAnalysisDraft)

        window.location.replace('/login');
    }

    function updateUser(user: CounselorLoginType | StudentLoginType, token?: string | undefined) {
        cookies.set('currentUser', JSON.stringify({user: user, token: token || cookies.get('currentUser')?.['token']}), {path: '/', maxAge: 2000000})
        if (user.role === 2) {
            (user as StudentUserType).special.profilePic = user.profilePic;
            (user as StudentUserType).special.name = user.name;
            setUser(user as StudentUserType);
        } else if (user.role === 1) {
            (user as CounselorUserType).special.name = user.name;
            (user as CounselorUserType).special.profilePic = user.profilePic;
            setUser(user as CounselorUserType);
        }
    }

    function updateScore() {
        axios.post('v2/student/coinsCount')
            .then((res) => {
                const newUser = {...user};
                newUser.score = res.data;
                cookies.set('currentUser', JSON.stringify({user: newUser, token: cookies.get('currentUser')?.['token']}), {path: '/', maxAge: 86400})
                setUser(newUser);
            })
    }

    async function subscribeToFCM(fcm_token: string) {
        setFCMToken(fcm_token);
        const formData = {user_id: user.id, fcm_token: fcm_token}
        const response = await axios.post('fcm_token', formData);
    }

    useEffect(() => {
        async function initial() {
            console.log(cookies.get('adminUser'));
            const location = window.location.pathname;
            const pathIncludingParams = window.location.href;
            if (!user && !(location.includes('login') || location.includes('register') || location.includes('demo') || location.includes('payment') || location.includes('referral') || location.includes('challengePayment') || location.includes('external-login'))) {
                window.location.replace('/login?redirect=' + pathIncludingParams.substring(pathIncludingParams.lastIndexOf('/')));
                return;
            }

            if (user) {
                requestForToken(subscribeToFCM);
                // posthog?.identify(user.phoneNumber, {})
            }
        }

        initial()
    }, [user])

    const context = {
        user,
        FCMToken,
        token,
        logout,
        updateUser,
        updateScore
    };

    return (
        <UserContext.Provider value={context}>
            {children}
        </UserContext.Provider>
    )
}

export default UserContext;
